import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SiTextField from "../../../core/si-textfield";
import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import FormGenerator from "../../../core/form-generator";
import {
  ADDITIONAL_ADVANCE_FORM1,
  ADVANCE_FORM1,
  ADVANCE_FORM2,
  INWARD_FORM1,
  INWARD_FORM2,
} from "./helper";
import { formatDate, handleFormValidation } from "../../../utils";
import CustomButtonComponent from "../../../core/custom-button";
import { DATE_FORMATS } from "../../../utils/constants";
import SiAutocomplete from "../../../core/si-autocomplete";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import ClearIcon from "@mui/icons-material/Clear";

const AdvanceEngineReplacementForm = () => {
  const [ticketDetail, setTicketDetails] = useState({});
  const [selectedSearchType, setSelectedSearchType] = useState("FieldWarranty");
  const [staticFormData, setStaticFormData] = useState({});
  const [selectedSearchEngine, setSelectedSearchEngine] = useState("");
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [engineReplacementId, setEngineReplacementId] = useState(null);
  const [searchEngineOptions, setSearchEngineOptions] = useState([]);
  const [oems, setOems] = useState([]);
  const [additionalEngineList, setAdditionalEngineList] = useState([]);
  const [additionalEngine, setAdditionalEngine] = useState("");
  let engineTimeout = null;
  let oemTimeout = null;

  const loadEngines = async (inputValue) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.GET,
        `${HOSTNAME}${REST_URLS.SEARCH_ENGINE}`,
        null,
        { searchTerm: inputValue }
      );
      setSearchEngineOptions(
        response.map((item) => ({
          label: item,
          value: item,
        }))
      );
    } catch (error) {
      console.error("Error fetching engine options:", error);
    }
  };
  const loadOems = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOems(result);
        }
      })
      .catch((err) => console.error(err));
  };

  const handleEngineSearch = (newInputValue) => {
    if (newInputValue) {
      clearTimeout(engineTimeout);
      engineTimeout = setTimeout(() => loadEngines(newInputValue), 300);
    }
  };
  const submitWorkOrder = () => {
    const isValid = handleFormValidation(
      selectedSearchType === "AdditionalAdvance"
        ? [...ADVANCE_FORM2, ...ADDITIONAL_ADVANCE_FORM1(oems)]
        : [...ADVANCE_FORM2],
      setErrors,
      selectedSearchType === "AdditionalAdvance"
        ? { ...formData, ...staticFormData }
        : formData
    );
    if (isValid) {
      let payload = {
        ...formData,
        advanceEngineNumber:
          selectedSearchType === "AdditionalAdvance"
            ? additionalEngine?.value?.value
            : selectedSearchEngine?.value,
      };
      if (selectedSearchType === "AdditionalAdvance") {
        payload = {
          ...payload,
          ...staticFormData,
          isAdditionalEngine: true,
          oem: staticFormData?.oem?.value,
        };
      }
      if (engineReplacementId) {
        delete payload.advanceEngineNumber;
        delete payload.isAdditionalEngine;
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.ADVANCE_ENGINE_REPLACEMENT}/${engineReplacementId}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Advance engine Updated Successfully");
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.ADVANCE_ENGINE_REPLACEMENT}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Advance Engine Replacement");
              getAdditionalEnginesList();
              setStaticFormData({});
              setFormData({});
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const getTicketEngineDetails = (value) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.ADVANCE_ENGINE_REPLACEMENT}/info`,
      null,
      { engineSerialNumber: value }
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          if (res?.ticket) {
            setTicketDetails(res.ticket);
            setStaticFormData({ ...res.ticket, oem: res.ticket?.oemOrg?.name });
            if (res.advancedEngineReplacementInfo) {
              const { advancedEngineReplacementInfo } = res;
              setFormData((prevVal) => ({
                ...prevVal,
                advancedEngineInvoiceDate: formatDate(
                  advancedEngineReplacementInfo.advancedEngineInvoiceDate,
                  DATE_FORMATS["YYYY-MM-DD"]
                ),
                advancedEngineInvoiceNo:
                  advancedEngineReplacementInfo.advancedEngineInvoiceNo,
                depotLocation: advancedEngineReplacementInfo.depotLocation,
                docketNumber: advancedEngineReplacementInfo.docketNumber,
                invoiceValue: advancedEngineReplacementInfo.invoiceValue,
                taxValue: advancedEngineReplacementInfo.taxValue,
                transporter: advancedEngineReplacementInfo.transporter,
              }));
              setEngineReplacementId(advancedEngineReplacementInfo.id);
            }
          } else if (res?.advancedEngineReplacementInfo) {
            const { advanceEngineNumber, oem, listNumber, plant } =
              res?.advancedEngineReplacementInfo;
            const advancedEngineReplacementInfo =
              res?.advancedEngineReplacementInfo;
            setStaticFormData({
              advanceEngineNumber,
              oem: oems.find((ele) => ele.value === oem),
              listNumber,
              plant,
            });
            setFormData((prevVal) => ({
              ...prevVal,
              advancedEngineInvoiceDate: formatDate(
                advancedEngineReplacementInfo.advancedEngineInvoiceDate,
                DATE_FORMATS["YYYY-MM-DD"]
              ),
              advancedEngineInvoiceNo:
                advancedEngineReplacementInfo.advancedEngineInvoiceNo,
              depotLocation: advancedEngineReplacementInfo.depotLocation,
              docketNumber: advancedEngineReplacementInfo.docketNumber,
              invoiceValue: advancedEngineReplacementInfo.invoiceValue,
              taxValue: advancedEngineReplacementInfo.taxValue,
              transporter: advancedEngineReplacementInfo.transporter,
            }));
            setEngineReplacementId(advancedEngineReplacementInfo.id);
          }
        }
      })
      .catch((err) => console.error(err));
  };
  const handleSearchTypeChange = (event) => {
    setStaticFormData({});
    setFormData({});
    setEngineReplacementId(null);
    setSelectedSearchType(event.target.value);
    setSelectedSearchEngine("");
    setAdditionalEngine("");
    setErrors({});
  };
  const getAdditionalEnginesList = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.ADVANCE_ENGINE_REPLACEMENT}/advanced-engine-models`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const list = res?.map((ele) => ({ label: ele, value: ele }));
          setAdditionalEngineList(list);
        }
      })
      .catch((err) => console.error(err));
  };
  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.ADVANCE_ENGINE_REPLACEMENT}`,
      null,
      { download: true },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Advance Engine Replacement.csv");
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const searchHandler = () => {
    let value = "";
    if (selectedSearchType === "AdditionalAdvance") {
      value = additionalEngine?.value;
    } else {
      value = selectedSearchEngine?.value;
    }
    getTicketEngineDetails(value);
  };
  useEffect(() => {
    if (selectedSearchType === "AdditionalAdvance") {
      loadOems();
      getAdditionalEnginesList();
    }
  }, [selectedSearchType]);
  console.log(staticFormData);
  return (
    <div className="page-body">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <p className="tab-name">Float Engine Movements</p>
          <p className="section-name">Advance Engine Replacement</p>
        </div>
        <Box sx={{ display: "flex", gap: "16px", alignItems: "center", mr: 6 }}>
          <CustomButtonComponent
            variant="contained"
            color="success"
            onClick={downloadReports}
          >
            Download All
          </CustomButtonComponent>
        </Box>
      </Box>
      <div className="form-con mt-0">
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <Grid item md={5}>
            <RadioGroup
              row
              value={selectedSearchType}
              onChange={handleSearchTypeChange}
            >
              <FormControlLabel
                value="FieldWarranty"
                control={<Radio />}
                label="Field Warranty Engine List"
              />
              <FormControlLabel
                value="AdditionalAdvance"
                control={<Radio />}
                label="Additional Advance Engine"
              />
            </RadioGroup>
          </Grid>
          <Grid item md={3}>
            {selectedSearchType === "AdditionalAdvance" ? (
              <div>
                <p style={{ marginTop: "0px" }}>
                  Additional Field Engine - Inward
                </p>
                <SiAutocomplete
                  value={additionalEngine}
                  onChange={setAdditionalEngine}
                  options={additionalEngineList}
                  placeholder="Additional Field Engine"
                  onInputChange={(newInputValue) =>
                    handleEngineSearch(newInputValue)
                  }
                  clearIcon={
                    <ClearIcon
                      fontSize="small"
                      onClick={() => {
                        setStaticFormData({});
                        setFormData({});
                        setEngineReplacementId(null);
                      }}
                    />
                  }
                />
              </div>
            ) : (
              <div>
                <p style={{ marginTop: "0px" }}>
                  Field Warranty Engine - Inward
                </p>
                <SiAutocomplete
                  value={selectedSearchEngine}
                  onChange={setSelectedSearchEngine}
                  options={searchEngineOptions}
                  placeholder="Field Warranty Engine"
                  onInputChange={(newInputValue) =>
                    handleEngineSearch(newInputValue)
                  }
                  clearIcon={
                    <ClearIcon
                      fontSize="small"
                      onClick={() => {
                        setStaticFormData({});
                        setFormData({});
                        setEngineReplacementId(null);
                      }}
                    />
                  }
                />
              </div>
            )}
          </Grid>
          <Grid item md={1} xs={1}></Grid>
          <Grid item md={2}>
            <CustomButtonComponent
              variant="contained"
              fullWidth
              startIcon={<SearchTwoToneIcon />}
              color="success"
              disabled={!selectedSearchEngine && !additionalEngine}
              onClick={searchHandler}
            >
              Search
            </CustomButtonComponent>
          </Grid>
        </Grid>
      </div>
      <div className="form-con">
        {selectedSearchType === "AdditionalAdvance" ? (
          <FormGenerator
            errors={errors}
            setErrors={setErrors}
            config={ADDITIONAL_ADVANCE_FORM1(oems)}
            formData={staticFormData}
            setFormData={setStaticFormData}
          />
        ) : (
          <FormGenerator
            errors={errors}
            setErrors={setErrors}
            config={ADVANCE_FORM1}
            formData={staticFormData}
            setFormData={setStaticFormData}
          />
        )}
      </div>
      <div className="form-con">
        <FormGenerator
          errors={errors}
          setErrors={setErrors}
          config={ADVANCE_FORM2}
          formData={formData}
          setFormData={setFormData}
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 2 }}>
          <CustomButtonComponent
            variant="contained"
            sx={{ width: { md: "20%", xs: "100%" } }}
            onClick={submitWorkOrder}
            disabled={
              selectedSearchType === "FieldWarranty" && !selectedSearchEngine
            }
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default AdvanceEngineReplacementForm;
